import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  set(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): any {
    const existsKey = localStorage.getItem(key);

    if (!existsKey) { return null; }

    return JSON.parse(existsKey);
  }

  clear(): void {
    localStorage.clear();
  }

  hasAuth(module: string, action?: string): boolean {
    const session = this.get('user');

    if (!session) { return false; }

    const permissions = this.parserPermissions(session.permisos);

    const exists = permissions.find( p => p.module === module);

    if (exists && !action) { return true; }

    if (exists && exists.actions.find( a => a === action )) { return true; }

    return false;
  }

  parserPermissions(permission: string): Array<any> {
    const chunks = permission.split(',');
    return chunks.map( c => c.split(':') ).map( c => ({module: c[0], actions: c.slice(1)}) );
  }
}
